import { useState } from 'react';
import { useCheckIn } from '~/hooks';
import { Button, Spinner } from '~/components';

import css from './ClaimYourToken.module.css';

export function ClaimYourToken() {
  const { checkIn, userStats, isLoading, error, isConnected } = useCheckIn();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleCheckIn = async () => {
    try {
      setSuccessMessage(null);
      await checkIn();
      setSuccessMessage('Successfully checked in!');
    } catch {
      // Error is handled by the hook
    }
  };

  const formatDate = (date: Date | null) => {
    if (!date) {
      return 'Never';
    }
    return date.toLocaleString();
  };

  return (
    <div className={css.wrapper}>
      <div className={css.circle}>🎉</div>
      <h1 className={css.title}>Daily Check-In</h1>

      {!isConnected ? (
        <p className={css.description}>
          Please connect your wallet to participate in the Daily Check-In event.
        </p>
      ) : (
        <>
          <p className={css.description}>
            Check in daily to earn rewards and track your consistency on the
            blockchain.
          </p>

          <div className={css.statsContainer}>
            <div className={css.statItem}>
              <span className={css.statLabel}>Total Check-ins:</span>
              <span className={css.statValue}>{userStats?.count ?? 0}</span>
            </div>
            <div className={css.statItem}>
              <span className={css.statLabel}>Last Check-in:</span>
              <span className={css.statValue}>
                {formatDate(userStats?.lastCheckInDate ?? null)}
              </span>
            </div>
          </div>

          <Button
            className={css.checkInButton}
            onClick={handleCheckIn}
            disabled={isLoading}
          >
            {isLoading ? <Spinner /> : 'Check In Now'}
          </Button>

          {error && <div className={css.error}>{error}</div>}
          {successMessage && (
            <div className={css.success}>{successMessage}</div>
          )}
        </>
      )}
    </div>
  );
}
